import React, { forwardRef } from 'react';
import { Skeleton } from '@fourthwall/components';
import * as S from './ChartContainer.styled';
export const ChartContainer = forwardRef(({ isEmpty, emptyMessage = 'No data', isLoading, children }, ref) => {
    if (isLoading) {
        return (React.createElement(S.Container, null,
            React.createElement(Skeleton.Shape, { width: "100%", height: "100%" })));
    }
    if (isEmpty) {
        return (React.createElement(S.Container, null,
            React.createElement(S.EmptyMessage, null, emptyMessage)));
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Chart, { ref: ref }, children)));
});
